<mat-card>
    <section style="   
    padding: 16px 16px 0;">
    <!-- <mat-card-header> -->

        <div class="row">
            <mat-card-title class="text-xl">Sellos digitales</mat-card-title>
        </div>
        <div class="row">
        <mat-card-subtitle class="text-secondary">
            <div class="row">
                <div class="col-md-10">
                    Es importante que subas tus sellos digitales, ya que sin ellos no podrás emitir facturas.
                </div>
                <div class="col-md-2">
                    <span style="
                            font-size: 12px; font-weight: 400; color: red;">
                        Obligatorio para emisión de facturas.
                    </span>

                    <!-- <div class="alert alert-danger" role="alert">
                        Error al facturar
                      </div> -->
                </div>

            </div>
        </mat-card-subtitle></div>
        <!-- </mat-card-header> -->
    </section>
    <mat-card-content>

        <form [formGroup]="stampForm">

            <!-- Divider -->
            <mat-divider class="mt-6 mb-6"></mat-divider>

            <div class="grid sm:grid-cols-4 gap-6 w-full mt-8">

                <!-- CER -->
                <div class="sm:col-span-2">
                    <mat-label>Sube tu archivo .CER <span class="required">*</span></mat-label>
                    <app-upload-files *ngIf="!cargando" [disabled]="!cargarArchivos"
                        (uploaded)="fileBrowseHandlerCer($event)" [accept]="'.cer'">
                    </app-upload-files>

                    <ng-container *ngIf="loadCer">
                        <div class="flex items-center">
                            <mat-icon class="icon-size-5 text-primary"
                                [svgIcon]="'heroicons_solid:check-circle'"></mat-icon>
                            <div class="ml-2">Archivo guardado.</div>

                        </div>
                    </ng-container>
                </div>
                <!-- KEY -->
                <div class="sm:col-span-2">
                    <mat-label>Sube tu archivo .KEY <span class="required">*</span></mat-label>
                    <app-upload-files *ngIf="!cargando" [disabled]="!cargarArchivos" (uploaded)="fileBrowseHandlerKey($event)"
                        [accept]="'.key'"></app-upload-files>
                    <ng-container *ngIf="loadKey">
                        <div class="flex items-center">
                            <mat-icon class="icon-size-5 text-primary"
                                [svgIcon]="'heroicons_solid:check-circle'"></mat-icon>
                            <div class="ml-2">Archivo guardado.</div>
                        </div>
                    </ng-container>
                </div>
            </div>
            <!-- Divider -->
            <mat-divider class="mt-6 mb-6"></mat-divider>

            <div class="grid sm:grid-cols-4 gap-6 w-full mt-8">
                <!-- Contraseña -->
                <div class="sm:col-span-2">
                    <mat-label>Contraseña de los sellos digitales <span class="required">*</span></mat-label>
                    <mat-form-field>
                        <mat-icon class="icon-size-5" [svgIcon]="'heroicons_solid:key'" matPrefix></mat-icon>
                        <input id="contrasenia" matInput type="password" [formControlName]="'contrasenia'"
                            #passwordField>
                        <button mat-icon-button type="button"
                            (click)="passwordField.type === 'password' ? passwordField.type = 'text' : passwordField.type = 'password'"
                            matSuffix>
                            <mat-icon class="icon-size-5" *ngIf="passwordField.type === 'password'"
                                [svgIcon]="'heroicons_solid:eye'"></mat-icon>
                            <mat-icon class="icon-size-5" *ngIf="passwordField.type === 'text'"
                                [svgIcon]="'heroicons_solid:eye-off'"></mat-icon>
                        </button>
                        <mat-error>
                            La contraseña es requerida
                        </mat-error>
                    </mat-form-field>
                </div>
                <div class="sm:col-span-1" *ngIf="files?.attributes?.cer">
                    <mat-label>&nbsp;</mat-label>
                    <button mat-button matTooltip="Descargar certificado CER"
                        (click)="downloadFile(files.attributes.cer)">
                        <mat-icon>download</mat-icon>
                        cer.
                    </button>
                </div>
                <div class="sm:col-span-1" *ngIf="files?.attributes?.key">
                    <mat-label>&nbsp;</mat-label>
                    <button mat-button matTooltip="Descargar certificado KEY"
                        (click)="downloadFile(files.attributes.key)">
                        <mat-icon>download</mat-icon>
                        key.
                    </button>
                </div>

            </div>

            <div class="grid sm:grid-cols-4 gap-6 w-full mt-8">
                <div class="col-span-2 sm:col-span-1 align-center">
                    <mat-label>Número de certificado <div>{{noCertificado}}</div></mat-label>
                </div>
                <div class="col-span-2 sm:col-span-1 align-center">
                    <mat-label>Vigencia <div>{{vigencia | date: 'dd-MM-yyyy'}}</div></mat-label>
                </div>
            </div>

            <!-- Actions -->
            <div class="flex items-center justify-end mt-5">
                <button class="ml-4" mat-flat-button type="button" [disabled]="!stampForm.valid" (click)="uploadFile()"
                    [color]="'primary'"> Guardar
                    Sellos Digitales
                </button>

                <!-- <button class="ml-4" mat-flat-button type="button" (click)="uploadFile()" [color]="'primary'"> 
                    Test
                </button> -->
            </div>

        </form>

    </mat-card-content>
</mat-card>

<br />
<settings-company-fiel [idEmpresa]="idEmpresa" [status]="status"></settings-company-fiel>